var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZumoLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": titleId,
    width: 164,
    height: 37,
    viewBox: "0 0 164 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_993_12907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.5985 0.369446H65.3316C64.0481 0.369446 63.005 1.41181 63.005 2.69432V23.8952C63.005 26.922 59.4582 29.2707 56.4079 29.2707C53.3576 29.2707 49.8108 26.922 49.8108 23.8952V2.69432C49.8108 1.41181 48.7676 0.369446 47.4841 0.369446H44.2173C42.9338 0.369446 41.8906 1.41181 41.8906 2.69432V24.489C41.8906 34.3664 51.0151 37.0026 56.4053 37.0026C64.1432 37.0026 70.9199 32.6801 70.9199 24.489V2.69432C70.9199 1.41181 69.8767 0.369446 68.5932 0.369446H68.5985Z",
    fill: "url(#paint0_linear_993_12907)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.636 0C104.394 0 101.18 2.19292 99.7668 3.44904C97.3107 1.25084 93.7323 0 89.8606 0C82.4607 0 76.2017 4.42279 76.2017 12.4688V34.1764C76.2017 35.4589 77.2448 36.5012 78.5283 36.5012H81.4202C82.7037 36.5012 83.7468 35.4589 83.7468 34.1764V13.0599C83.7468 10.0463 87.0348 7.70822 89.8606 7.70822C92.6864 7.70822 95.9744 10.0463 95.9744 13.0599V34.1737C95.9744 35.4562 97.0176 36.4986 98.3011 36.4986H101.196C102.479 36.4986 103.522 35.4562 103.522 34.1737V13.0599C103.522 10.0463 106.81 7.70822 109.639 7.70822C112.467 7.70822 115.755 10.0463 115.755 13.0599V34.1737C115.755 35.4562 116.798 36.4986 118.082 36.4986H120.971C122.254 36.4986 123.298 35.4562 123.298 34.1737V12.4688C123.298 2.13751 114.049 0 109.641 0H109.636Z",
    fill: "url(#paint1_linear_993_12907)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.624 0.0923462C134.846 0.0923462 128.109 4.44389 128.109 12.6034V24.3491C128.109 32.9915 135.398 36.8601 142.624 36.8601C150.256 36.8601 157.139 32.6273 157.139 24.3491V12.6034C157.139 3.96097 149.85 0.0923462 142.624 0.0923462ZM136.027 13.1971C136.027 10.3972 139.109 7.94043 142.624 7.94043C146.139 7.94043 149.221 10.3972 149.221 13.1971V23.758C149.221 26.5579 146.139 29.0147 142.624 29.0147C139.109 29.0147 136.027 26.5579 136.027 23.758V13.1971Z",
    fill: "url(#paint2_linear_993_12907)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4712 15.1605C32.003 15.1737 33.3921 13.9387 33.3921 12.2656C33.3921 10.5925 31.9924 9.36018 30.4712 9.37338H26.1374C25.2554 9.37338 24.5344 8.65296 24.5344 7.77421C24.5344 6.89545 25.2554 6.17239 26.1374 6.17239H35.4864C37.1977 6.17239 38.4046 4.7685 38.4046 3.25641C38.4046 1.74432 37.1739 0.343068 35.4864 0.345707H3.54679C1.59249 0.345707 0 1.93696 0 3.89239V9.51588C0 10.7482 1.00356 11.751 2.23688 11.751H5.2053C6.43862 11.751 7.44218 10.7482 7.44218 9.51588V7.91671C7.44218 7.86393 7.46067 7.81643 7.49764 7.77948C7.53461 7.74254 7.58215 7.72143 7.63497 7.72143L18.4206 7.72671L0.934894 30.0439C0.332759 30.8144 0 31.7776 0 32.754V33.4876C0 35.1607 1.36273 36.5224 3.03709 36.5224H27.9227C29.8796 36.5224 31.4695 34.9311 31.4695 32.9783V27.3548C31.4695 26.1225 30.4659 25.1197 29.2326 25.1197H26.2642C25.0309 25.1197 24.0273 26.1225 24.0273 27.3548V28.9566C24.0273 29.0622 23.9402 29.1493 23.8345 29.1493H12.0559C11.8552 29.1493 11.6703 29.0332 11.5832 28.8537C11.496 28.6743 11.5198 28.4553 11.6413 28.2969L21.3996 15.8756C21.7587 15.4191 22.2949 15.1578 22.8759 15.1578H30.4712V15.1605Z",
    fill: "url(#paint3_linear_993_12907)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.991 6.22255C162.336 6.85325 161.552 7.16992 160.638 7.16992C159.725 7.16992 158.895 6.84533 158.248 6.1988C157.601 5.55227 157.276 4.75532 157.276 3.8106C157.276 2.86587 157.625 2.01351 158.325 1.36434C158.982 0.757392 159.751 0.453918 160.638 0.453918C161.526 0.453918 162.358 0.781142 163.015 1.43823C163.673 2.09531 164 2.88698 164 3.81324C164 4.73949 163.665 5.57074 162.991 6.22519V6.22255ZM158.663 1.86573C158.127 2.41198 157.86 3.06115 157.86 3.8106C157.86 4.56004 158.132 5.2488 158.676 5.79241C159.217 6.33602 159.87 6.60783 160.638 6.60783C161.407 6.60783 162.054 6.33338 162.595 5.78713C163.137 5.23824 163.406 4.57852 163.406 3.8106C163.406 3.04268 163.137 2.41462 162.598 1.86573C162.054 1.30628 161.399 1.02656 160.636 1.02656C159.872 1.02656 159.204 1.30628 158.66 1.86573H158.663ZM159.165 5.67894V1.95545C159.394 1.95545 159.74 1.95545 160.203 1.95545C160.662 1.95545 160.918 1.95809 160.971 1.96337C161.267 1.98448 161.51 2.04781 161.705 2.15601C162.035 2.33809 162.202 2.63365 162.202 3.04532C162.202 3.35935 162.115 3.58365 161.94 3.72351C161.766 3.86338 161.549 3.94518 161.296 3.97421C161.531 4.02171 161.705 4.0956 161.824 4.1906C162.043 4.3674 162.152 4.64713 162.152 5.02449V5.35699C162.152 5.39394 162.152 5.43088 162.159 5.46519C162.167 5.49949 162.173 5.53908 162.186 5.57338L162.22 5.67894H161.291C161.262 5.56019 161.24 5.38866 161.23 5.16435C161.219 4.94005 161.198 4.78699 161.169 4.70782C161.119 4.57852 161.029 4.48616 160.894 4.43338C160.821 4.40435 160.71 4.38324 160.562 4.37532L160.348 4.36213H160.142V5.67894H159.165ZM160.945 2.68907C160.81 2.63629 160.622 2.61254 160.379 2.61254H160.142V3.69185H160.519C160.747 3.69185 160.926 3.64699 161.053 3.55462C161.18 3.46226 161.243 3.31712 161.243 3.11393C161.243 2.91073 161.143 2.76823 160.942 2.68907H160.945Z",
    fill: "#DF2ACF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_993_12907",
    x1: -1.09603,
    y1: 18.686,
    x2: 153.827,
    y2: 18.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A5B9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#497FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#497FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#00ACEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF2ACF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_993_12907",
    x1: -1.09614,
    y1: 18.248,
    x2: 153.827,
    y2: 18.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A5B9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#497FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#497FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#00ACEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF2ACF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_993_12907",
    x1: -0.000203026,
    y1: 18.4776,
    x2: 153.827,
    y2: 18.4776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A5B9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#497FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#497FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#00ACEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF2ACF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_993_12907",
    x1: -1.09599,
    y1: 18.4327,
    x2: 153.827,
    y2: 18.4327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A5B9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#497FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#497FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#00ACEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF2ACF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_993_12907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZumoLogo);
export default __webpack_public_path__ + "static/media/ZumoLogo.4b5502a51cd84105b99162c60ded1b40.svg";
export { ForwardRef as ReactComponent };